import i18n from 'common/util/internationalization'
import { getPostHeaders } from 'common/util/requestUtils'
import emitter from 'common/util/events'
import { removeSessionStorageItem } from 'businesslayer/minutesLocalStore'

function hasStringContent(value: unknown): value is { content: string } {
    return (
        typeof value === 'object' &&
        value !== null &&
        'content' in value &&
        typeof (value as { content: unknown }).content === 'string'
    )
}

export function normalizeAiRewriteContent(content: unknown): string {
    if (typeof content === 'string') return content
    if (hasStringContent(content)) return content.content
    return ''
}

export function buildAiRewriteBody(sectionId: string, content: unknown): string {
    return JSON.stringify({
        section_id: sectionId,
        content: normalizeAiRewriteContent(content)
    })
}

export const fetchAiSupport = async (body) => {
    try {
        return fetch(`/api/ai_rewrites`, {
            method: 'POST',
            credentials: 'include',
            headers: getPostHeaders(),
            body
        }).then((response) => {
            if (response.status === 504) {
                throw new Error(i18n.t('AI_REWRITE_ERROR'))
            }
            if (response.status === 401) {
                const message = i18n.t('SESSION_EXPIRED_MESSAGE')
                removeSessionStorageItem('selectedStatusFilter')
                removeSessionStorageItem('selectedCommitteeFilter')
                emitter.emit('locked', { message })
                return Promise.reject(response)
            }
            const data = response.json()

            return data
        })
    } catch (error) {
        throw new Error(i18n.t('AI_REWRITE_ERROR'))
    }
}
